import { observer } from 'mobx-react-lite'
import {
  FirmDashboardQuickSelectFilter,
  FirmDashboardQuickSelectFilterCard,
  type QuickSelectOption,
} from '@/features/jobs/dashboard/components/FirmDashboardQuickSelectFilter'
import { type FirmDashboardQuickSelectFilterViewModel } from '@/features/jobs/dashboard/FirmDashboardQuickSelectFilterViewModel'

export interface FirmDashboardQuickSelectFilterContainerProps {
  vm: FirmDashboardQuickSelectFilterViewModel
}

export const FirmDashboardQuickSelectFilterContainer = observer(
  function FirmDashboardQuickSelectFilterContainer({
    vm,
  }: FirmDashboardQuickSelectFilterContainerProps) {
    if (!vm.hasStatusFilter) {
      return null
    }

    return (
      <FirmDashboardQuickSelectFilter>
        <QuickSelectFilterCardContainer
          vm={vm}
          title="Under construction"
          option="Onboarding"
        />
        {vm.isB2B2CWorkspace && (
          <QuickSelectFilterCardContainer
            vm={vm}
            title="Info gathering"
            option="InfoGathering"
          />
        )}
        <QuickSelectFilterCardContainer
          vm={vm}
          title="In progress"
          option="InProgress"
        />
        <QuickSelectFilterCardContainer
          vm={vm}
          title="Completed"
          option="Closed"
        />
      </FirmDashboardQuickSelectFilter>
    )
  },
)

interface QuickSelectFilterCardContainerProps {
  vm: FirmDashboardQuickSelectFilterViewModel
  title: string
  option: QuickSelectOption
}

const QuickSelectFilterCardContainer = observer(
  function QuickSelectFilterCardContainer({
    vm,
    title,
    option,
  }: QuickSelectFilterCardContainerProps) {
    return (
      <FirmDashboardQuickSelectFilterCard
        title={title}
        option={option}
        count={vm.getTotalJobsFilterCount(option)}
        isActive={vm.isOptionActive(option)}
        onPress={() => vm.toggleOption(option)}
      />
    )
  },
)
